/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceDetails {
    getFixupPrototypeFunction() { return ResourceDetails.fixupPrototype; }

    static newInstance(model: Partial<ResourceDetails>): ResourceDetails {
        let obj = Object.assign(new ResourceDetails(), model);
        ResourceDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceDetails>): ResourceDetails {
        if (!model) return null;
        return ResourceDetails.newInstance(<ResourceDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceDetails) {
        if (!obj) return;

        models.ResourceDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceDetails): boolean {
        Object.setPrototypeOf(obj, ResourceDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of that Template/Policy that is scheduled to run
     */
    id: string;

    /**
     * Name of the Template/Policy that is scheduled to run
     */
    name: string;

}
